import { queryOptions } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { LoginForm } from "@/features/auth/login";
import { useGoogleAnalytics } from "@/features/auth/login/hooks/useGoogleAnalytics";
import { usePageTitle } from "@/hooks/usePageTitle";
import apiClient from "@/lib/api/client";
import { getPostLoginRedirect } from "@/lib/whitelabel/domains";

export const Route = createFileRoute("/login")({
  beforeLoad: async ({ context, search }) => {
    try {
      const user = await context.queryClient.ensureQueryData(
        queryOptions({
          queryFn: () => apiClient.url("/users/me").get().json(),
          queryKey: ["user"],
          staleTime: Infinity,
        }),
      );

      if (user) {
        const dest =
          search.redirect?.startsWith("/") && !search.redirect.startsWith("//")
            ? search.redirect
            : getPostLoginRedirect();

        throw redirect({ href: dest });
      }
    } catch (error) {
      if (error && typeof error === "object" && "isRedirect" in error)
        throw error;
      // 401 = not logged in, render login form normally
    }
  },
  component: RouteComponent,
  validateSearch: z.object({
    redirect: z.string().optional(),
  }),
});

function RouteComponent() {
  usePageTitle("Log In");
  useGoogleAnalytics("G-90V33ZC40T");

  return <LoginForm />;
}
